// extracted by mini-css-extract-plugin
export default {"cls1":"SuggestedUserCard-cls1___745d0a28f9ba9cf4400","cls2":"SuggestedUserCard-cls2___5c891ceaae8deec2e04 SuggestedUserCard-cls1___745d0a28f9ba9cf4400"};